/* eslint-disable react/jsx-no-useless-fragment, jsx-a11y/anchor-is-valid */
import React from 'react';
import { domToReact } from 'html-react-parser';
import TooltipRegistry from './TooltipRegistry';
import TooltipWithId from './TooltipWithId';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';
import {
    classNames,
    attributeNames,
} from './Constants';
import * as CSS from "./qlTooltip.module.scss";

const registry = TooltipRegistry.instance();

function toTooltip( parserData )
{
    const { parserOptions: { replaceFn } }  = parserData;

    const Wrapper = ({
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs, 
        children = parserPropTypesDefaults.children,
    }) =>
    {
        if ( type !== 'tag' ) return null;
        if ( !name || name !== 'span' ) return null;
        if ( !attribs?.class || !attribs.class.includes( classNames.LAUNCH_FORMAT ) ) return null;

        const contentId = attribs?.[ attributeNames.POPOVER_CONTENT_ID_DATA ];

        return (
            <span className={CSS.qltooltipWrapper}>
                <TooltipWithId
                    disableTouchListener
                    disableHoverListener
                    placement="bottom"
                    size="medium"
                    contentId={contentId}
                >
                    <a className={CSS.qltooltipLauncher}>{
                        domToReact( children, replaceFn() )
                    }</a>
                </TooltipWithId>
            </span>
        )
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}
/* eslint-disable-next-line */
toTooltip.content = function( parserData )
{
    const { parserOptions: { replaceFn } } = parserData;
    const Wrapper = ({ 
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children
    }) => 
    {
        if ( type !== 'tag' ) return null;
        if ( !name || name !== 'div' ) return null;
        if ( !attribs?.class ) return null;
        if ( !attribs?.class.includes(classNames.POPOVER_CONTENT_BLOCK)) return null;

        const contentId = children?.find( (child) => child.attribs?.class.includes(classNames.POPOVER_CONTENT )).
            attribs[ attributeNames.POPOVER_LAUNCH_ID_DATA ];
        
        const childrenComps = domToReact( children, replaceFn() );
        registry.setContent( contentId, childrenComps );

        return <></>;
    }
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}

export default toTooltip;
